import { motion } from "framer-motion";
import { AnimatedCounter } from "@/components/AnimatedCounter";

const stats = [
  { value: 98, suffix: "%", label: "Taux de satisfaction", sub: "voyageurs" },
  { value: 85, suffix: "%", label: "Taux d'occupation", sub: "moyen annuel" },
  { value: 24, suffix: "/7", label: "Disponibilité", sub: "pour nos partenaires" },
  { value: 5, suffix: "", prefix: "", label: "Étoiles de service", sub: "qualité hôtelière" },
];

export function AnimatedStats() {
  return (
    <section className="py-16 bg-[#004333] relative overflow-hidden" data-testid="stats-section">
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "40px 40px" }} />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="text-center"
              data-testid={`stat-${i}`}
            >
              <div className="text-4xl md:text-5xl font-black text-white mb-2">
                <AnimatedCounter target={stat.value} suffix={stat.suffix} prefix={stat.prefix || ""} />
              </div>
              <p className="text-[#C9922A] font-semibold text-sm uppercase tracking-wider mb-0.5">{stat.label}</p>
              <p className="text-white/40 text-xs">{stat.sub}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
